import apiClient from '@shared/api'
import type INotificationQuery from '@shared/api/patients/resources/notifications/notification-query'
import type INotification from '@shared/api/patients/resources/notifications/notification'
import type IPaginatedNotification from '@shared/api/patients/resources/notifications/paginated-notification'

export const getNotificationsList = (
  params?: INotificationQuery
): Promise<IPaginatedNotification | INotification[]> => {
  return apiClient.get('/patients/notifications', { params })
}

export const resolveNotification = ({
  notificationId,
  payload,
}: {
  notificationId: string | string[] | undefined
  payload?: { selectedPatientId?: string; invalidReason?: string }
}) => {
  return apiClient.put(`/patients/notifications/${notificationId}`, payload)
}

export const getNotification = ({ notificationId }: { notificationId: string | string[] }): Promise<INotification> => {
  return apiClient.get(`/patients/notifications/${notificationId}`)
}
